import React from "react";
import Particles from "react-tsparticles";

function Particle() {
  return (
    <Particles
      id="tsparticles"
      params={{
        particles: {
          number: {
            value: 48,
            density: {
              enable: true,
              value_area: 1200,
            },
          },
          line_linked: {
            enable: false,
            opacity: 0.02,
          },
          move: {
            direction: "none",
            random: true,
            speed: 0.12,
          },
          size: {
            value: 1.6,
            random: true,
          },
          opacity: {
            value: 0.35,
            anim: {
              enable: true,
              speed: 0.4,
              opacity_min: 0.05,
            },
          },
        },
        interactivity: {
          events: {
            onclick: {
              enable: false,
            },
          },
        },
        retina_detect: true,
      }}
    />
  );
}

export default Particle;
